import React, { createContext, useReducer, Dispatch, PropsWithChildren } from "react";

export enum MessageType {
  Info = "INFO",
  Warning = "WARNING",
  Error = "ERROR",
}

export interface Message {
  type: MessageType;
  content: string;
}

type MessageState = Message | null;

type MessageAction = { type: "SET_MESSAGE"; payload: Message } | { type: "CLEAR_MESSAGE" };

interface MessageContextType {
  state: MessageState;
  dispatch: Dispatch<MessageAction>;
}

export const MessageContext = createContext<MessageContextType>({
  state: null,
  dispatch: () => {},
});

const messageReducer = (state: MessageState, action: MessageAction): MessageState => {
  switch (action.type) {
    case "SET_MESSAGE":
      return action.payload;
    case "CLEAR_MESSAGE":
      return null;
    default:
      return state;
  }
};

export const MessageProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer<React.Reducer<MessageState, MessageAction>>(messageReducer, null);
  return <MessageContext.Provider value={{ state, dispatch }}>{children}</MessageContext.Provider>;
};
